import { Link } from "react-router-dom";
import { BookOpenText } from "lucide-react";
import StrategyLibrary from "../components/StrategyLibrary";
import UserMenu from "../components/UserMenu";
import StartBuildingButton from "../components/StartBuildingButton";

const SkillsPage = () => {
  return (
    <div className="min-h-screen bg-[#f4f5f7] text-[#4a6984]">
      {/* Nav */}
      <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#1c2d3d]/95 border-b border-[#1c2d3d] shadow-lg shadow-[#1c2d3d]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-2">
          <Link
            to="/"
            data-testid="brand-logo"
            className="font-black text-base sm:text-lg tracking-tight text-white/80 hover:text-white inline-flex items-center gap-2 whitespace-nowrap shrink-0"
          >
            <img
              src="/brand/atomicedu-logo-mark.png"
              alt="Atomic Edu"
              className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0"
              data-testid="brand-logo-mark"
            />
            Atomic Edu
          </Link>
          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            <span className="hidden md:inline-flex">
              <StartBuildingButton />
            </span>
            <UserMenu />
          </div>
        </div>
      </header>

      <main className="pt-28 pb-20 max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <p className="font-bold uppercase text-xs tracking-[0.25em] text-[#4a6984]/70 inline-flex items-center gap-2">
              <BookOpenText className="h-3.5 w-3.5" /> Skills Library
            </p>
            <h1 className="mt-2 font-black text-3xl sm:text-4xl text-[#4a6984] tracking-tight">
              Skills Library
            </h1>
            <p className="mt-3 text-[#4a6984]/80 font-medium max-w-2xl">
              A reference for the seven Ontario transferable skills plus
              Self-Regulation. Open any card to find what the skill is, how
              it shows up in your classroom by grade, questions you can ask,
              and practices you can use tomorrow.
            </p>
          </div>
        </div>

        <StrategyLibrary />
      </main>
    </div>
  );
};

export default SkillsPage;
